import React from "react";
import Modal from "./Modal";
import { Link } from "react-router-dom";
import { HOME } from "src/constants/routes";

const Wallet = () => (
  <div className="heading">
    <h4 className="mb-1">Something went wrong!</h4>
    <p className="text pt-3">
      Please try to connect your wallet again.
    </p>
    <div className="body d-flex justify-content-center pt-4 me-4">
      <Link className="btn btn-primary continue text-white" to={HOME.INDEX}>
        Home
      </Link>
    </div>
  </div>
);

const IndividualArtWork = () => (
  <div className="heading">
    <h4 className="mb-1">Something went wrong!</h4>
    <p className="text pt-3">
      Your request is still processing. <br />
      Please check back in sometime..
    </p>
    <div className="body d-flex justify-content-center pt-4 me-4">
      <Link className="btn btn-primary continue text-white" to={HOME.INDEX}>
        Home
      </Link>
    </div>
  </div>
);

const InvalidGangstaModal = ({ isVisible, isWallet }) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="disconnect-modal card px-3 py-4"
    >
      {isWallet ? <Wallet /> : <IndividualArtWork />}
    </Modal>
  );
};

export default InvalidGangstaModal;
